import { CompanyRole } from "modules/company/constants";
import { EventRole } from "modules/event/constants";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IUser } from "modules/app/types";

export interface IAuthReducerState {
  signInTime?: Date;
  user?: IUser;
  role?: string;
  roles: string[];
  isLoading: boolean;
  isAdmin: boolean;
  isManager: boolean;
  isEventHelper: boolean;
  isTokenSyncedWithServer: boolean;
}

// Initial user state
export const initialState: IAuthReducerState = {
  signInTime: undefined,
  user: undefined,
  role: undefined,
  roles: ["user"],
  isLoading: true,
  isAdmin: false,
  isManager: false,
  isEventHelper: false,
  isTokenSyncedWithServer: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state: IAuthReducerState, action: PayloadAction<IUser>) => {
      state.user = action.payload;
      state.signInTime = new Date();
    },
    setCheckStatus: (
      state: IAuthReducerState,
      action: PayloadAction<boolean>,
    ) => {
      state.isLoading = action.payload;
    },
    setIsAdmin: (state: IAuthReducerState, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload;
    },
    setUserCompanyRole: (
      state: IAuthReducerState,
      action: PayloadAction<string>,
    ) => {
      state.role = action.payload;
      state.isManager = action.payload === CompanyRole.MANAGER;
      state.isEventHelper = action.payload === EventRole.helper;
    },
    resetAuth: () => ({ ...initialState, isLoading: false }),
    updateUser: (state: IAuthReducerState, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
    updateTokenSyncStatus: (
      state: IAuthReducerState,
      action: PayloadAction<boolean>,
    ) => {
      state.isTokenSyncedWithServer = action.payload;
    },
  },
});

export const {
  setAuth,
  setCheckStatus,
  setIsAdmin,
  setUserCompanyRole,
  resetAuth,
  updateUser,
  updateTokenSyncStatus,
} = authSlice.actions;

export default authSlice.reducer;
